import { createContext, useContext } from 'react'
import { planHasFeature, type PlanFeature } from '@/lib/platformPlanFeatures'

export type ShopWriteLockState = {
  /** False when ShopQuay subscription/trial is inactive — view only. */
  writesAllowed: boolean
  loading: boolean
  planCode: string
  features: string[]
  hasFeature: (feature: PlanFeature) => boolean
}

const ShopWriteLockContext = createContext<ShopWriteLockState>({
  writesAllowed: true,
  loading: false,
  planCode: 'trial',
  features: [],
  hasFeature: () => true,
})

export const ShopWriteLockProvider = ShopWriteLockContext.Provider

export function useShopWriteLock(): ShopWriteLockState {
  return useContext(ShopWriteLockContext)
}

export function planEntitlementValue(input: {
  writesAllowed: boolean
  loading: boolean
  planCode?: string
  features?: string[]
}): ShopWriteLockState {
  const planCode = input.planCode || 'trial'
  const features = input.features || []
  return {
    writesAllowed: input.writesAllowed,
    loading: input.loading,
    planCode,
    features,
    hasFeature: (feature) =>
      features.length > 0 ? features.includes(feature) : planHasFeature(planCode, feature),
  }
}
